import { motion } from "framer-motion";
import { Leaf, Flame, CloudOff, Truck, FlaskConical, IndianRupee } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const REASONS = [
  { icon: Leaf, title: "100% Pure Biomass", text: "Made entirely from natural biomass with zero adhesive and zero sulphur." },
  { icon: Flame, title: "High Calorific Value", text: "Up to 4000–4500 kcal/kg for stronger, longer-lasting heat output." },
  { icon: CloudOff, title: "Low Ash Content", text: "≤ 2–4% ash means cleaner burn, less residue and easier maintenance." },
  { icon: Truck, title: "Pan-India Dispatch", text: "Reliable logistics network for timely delivery across India." },
  { icon: FlaskConical, title: "In-House Quality Testing", text: "Every batch checked for moisture, GCV and ash before dispatch." },
  { icon: IndianRupee, title: "Cost Efficient Fuel", text: "A smarter, greener per-ton economics versus coal and fossil fuels." },
];

export const WhyChoose = () => (
  <section id="why-choose" data-testid="why-choose-section" className="bg-[#071009] py-20 lg:py-32">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow>The KARM Advantage</Eyebrow>
        <h2 className="font-display mt-4 max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="why-choose-heading">
          Why Choose KARM INDUSTRIES
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {REASONS.map((r, i) => (
          <motion.div
            key={r.title}
            data-testid={`why-card-${i}`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -6 }}
            className="group rounded-2xl border border-emerald-500/15 bg-[#0B150F] p-7 transition-colors duration-300 hover:border-emerald-500/45 hover:bg-[#101F16]"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-950 text-emerald-400 transition-colors duration-300 group-hover:bg-emerald-500 group-hover:text-[#050B07]">
              <r.icon className="h-6 w-6" />
            </div>
            <h3 className="font-display mt-5 text-lg font-bold text-white">{r.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{r.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
